"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _useResolutionCheck2 = _interopRequireDefault(require("../useResolutionCheck"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Dialog = function Dialog(_ref) {
  var className = _ref.className,
    open = _ref.open,
    fullScreen = _ref.fullScreen,
    fullWidth = _ref.fullWidth,
    maxWidth = _ref.maxWidth,
    children = _ref.children,
    disableScrollLock = _ref.disableScrollLock;
  var _useResolutionCheck = (0, _useResolutionCheck2["default"])(),
    isMobile = _useResolutionCheck.isMobile;
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
    className: className,
    fullWidth: fullWidth,
    fullScreen: fullScreen,
    maxWidth: maxWidth,
    open: open,
    scroll: isMobile ? 'body' : 'paper',
    disableScrollLock: disableScrollLock
  }, children);
};
Dialog.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  fullScreen: _propTypes["default"].bool,
  open: _propTypes["default"].bool.isRequired,
  fullWidth: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].string,
  disableScrollLock: _propTypes["default"].bool
};
Dialog.defaultProps = {
  className: '',
  fullScreen: false,
  fullWidth: true,
  maxWidth: 'md',
  disableScrollLock: false
};
var _default = exports["default"] = Dialog;